
import { computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import VersionControl from "@/helpers/pages/VersionControl";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Field, Form, ErrorMessage } from "vee-validate";

export default defineComponent({
  name: "VersionControl",
  data() {
    const schema = Yup.object().shape({
      apiKey: Yup.string().required().max(255).label("Api Key"),
      apiUrl: Yup.string().url().required().max(255).label("Api URL"),
    });
    return {
      schema,
      module: VersionControl,
    };
  },
  setup() {
    const store = useStore();
    const settings = computed(() => store.getters.settings);
    let formValues = ref({
      apiUrl: "",
      apiKey: "",
    });
    let apiUrl = ref("");

    store
      .dispatch(
        GeneralActionTypes.GET_SETTINGS,
        "3fa85f64-5717-4562-b3fc-2c963f66afa6"
      )
      .then(() => {
        if (settings.value && settings.value.credentials) {
          formValues.value = {
            apiUrl: settings.value.credentials.apiUrl,
            apiKey: settings.value.credentials.apiKey,
          };
        }
      });

    const submitFunction = function (e: any) {
      Swal.fire({
        title: "Are You Sure?",
        text: "You are about to update the selected item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            userGuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            credentials: {
              id: 0,
              apiKey: e.apiKey,
              apiUrl: e.apiUrl,
            },
          };
          store
            .dispatch(GeneralActionTypes.UPDATE_SETTINGS, data)
            .then((response: any) => {
              if (Number(response.statusCode) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire("Success!", "Version has been updated!", "success");
              }
            })
            .catch((e: any) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    };

    return {
      submitFunction,
      settings,
      formValues,
    };
  },
  components: { AgCard, Field, Form, ErrorMessage },
});
